import { useNavigate } from "react-router-dom";
import { Pencil } from "lucide-react";
import { CardInformado } from "@/modules/visitantes/components/CardInformado";
import { useMarcarAvisoLido, useMinhasIndicacoes } from "@/modules/visitantes/hooks/useVisitantes";

const BOTAO =
  "inline-flex min-h-9 items-center gap-1.5 rounded-lg border border-border bg-transparent px-3 text-[13px] font-semibold text-text transition-colors hover:bg-surface-2 disabled:cursor-not-allowed disabled:opacity-50";

/** "Meus pendentes": os Visitantes pendentes que este líder/gestor cadastrou e o que o ministério responsável decidiu. */
export function AbaMeusInformados() {
  const navigate = useNavigate();
  const { data = [], isLoading, isError, refetch } = useMinhasIndicacoes(true);
  const marcar = useMarcarAvisoLido();

  return (
    <div>
      {isLoading && <p className="py-8 text-center text-sm text-muted">Carregando…</p>}
      {isError && (
        <p role="alert" className="py-8 text-center text-sm text-danger">
          Não foi possível carregar.{" "}
          <button type="button" onClick={() => refetch()} className="font-semibold underline">
            Tentar de novo
          </button>
        </p>
      )}
      {!isLoading && !isError && data.length === 0 && (
        <p className="py-8 text-center text-sm text-muted">
          Você ainda não cadastrou nenhum visitante pendente. Use “Novo” quando alguém que você
          conhece visitar a igreja: o ministério responsável decide se adiciona.
        </p>
      )}
      <ul className="flex flex-col gap-3">
        {data.map((i) => (
          <CardInformado key={i.id} informado={i} visao="autor">
            {i.situacao === "pendente" && (
              <button
                type="button"
                className={BOTAO}
                onClick={() => navigate(`/visitantes/informados/${i.id}/editar`)}
              >
                <Pencil size={14} aria-hidden="true" /> Editar
              </button>
            )}
            {i.situacao !== "pendente" && i.aviso_lido === false && (
              <button
                type="button"
                className={BOTAO}
                disabled={marcar.isPending}
                onClick={() => marcar.mutate(i.id)}
              >
                Entendi
              </button>
            )}
          </CardInformado>
        ))}
      </ul>
    </div>
  );
}
